module.exports = __webpack_public_path__ + "img/tab-10.c18f6697.png";